











































import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import ChatMessageData, { MESSAGE_TYPE } from '../vo/ChatMessageData';

@Component({
	components:{}
})
export default class ChatMessage extends Vue {

	@Prop()
	public data:any;

	public elementIcons:__WebpackModuleApi.RequireContext = null;
	public TYPE_ELEMS_TO_CONST:string = MESSAGE_TYPE.ELEMS_TO_CONST;
	public TYPE_CONST_TO_STAR:string = MESSAGE_TYPE.CONST_TO_STAR;
	public TYPE_CONST_TO_ANGLES:string = MESSAGE_TYPE.CONST_TO_ANGLES;
	public TYPE_SPLITTER:string = MESSAGE_TYPE.SPLITTER;
	public TYPE_HELP:string = MESSAGE_TYPE.HELP;

	public get userFrom():string {
		let userList = this.$store.state.room.users;
		for (let i = 0; i < userList.length; i++) {
			if(userList[i].id == this.data.from) return userList[i];
		}
	}

	public get classes():string[] {
		let res = ["chatmessage"];
		if(this.data.type == MESSAGE_TYPE.SPLITTER) {
			res.push("splitter");
		}
		if(this.data.type == MESSAGE_TYPE.HELP) {
			res.push("help");
		}
		if(this.data.from == this.$store.state.me.id) {
			res.push("fromSelf");
		}
		return res;
	}

	public round(v):string {
		let res:number =  Math.round(parseInt(v));
		res = Math.min(Math.max(res, 1), 9);
		return res.toString();
	}

	public mounted():void {
		this.elementIcons = require.context("@/assets/icons");
	}

	public beforeDestroy():void {
		
	}

}
